// @flow
import { schema } from 'normalizr';
export var availabilitySchema = new schema.Entity('availabilities');
export var cardSchema = new schema.Entity('cards', {
  availabilities: [availabilitySchema]
});
//# sourceMappingURL=cardAvailability.js.map